export class Visibility {
  retailer_ids: any[];
  sale_point_ids: any[];
  user_ids: any[];
}

export class VisibilityObject {
  raw: Visibility;
  fullData: Visibility;
  isVisibleByAll: boolean;
}
